import {elementId} from "./helpers";
import {TextareaItem} from "../../model/items/textarea";
import {progressBarThermometerView} from "./progressBarThermometer";
import m, {VnodeDOM} from "mithril";

function cssHeight(a:any) {
    var sheets:any = document.styleSheets, o = [],
        i, r, rules;

    a.matches = a.matches || a.webkitMatchesSelector || a.mozMatchesSelector || a.msMatchesSelector || a.oMatchesSelector;

    for (i in sheets) {
        if (!sheets.hasOwnProperty(i)) {
            continue;
        }

        // In older FF accessing stylesheet from another domain throws security exception.
        try {
            rules = sheets[i].rules || sheets[i].cssRules;
        } catch (e) {
            continue;
        }

        for (r in rules) {
            if (!rules.hasOwnProperty(r)) {
                continue;
            }
            try {
                if (a.matches(rules[r].selectorText)) {
                    o.push(rules[r].style.height);
                }
            } catch (e) {
                continue;
            }
        }
    }

    return o;
}

export function textareaItemView(c:TextareaItem) {
    let isAutosize: boolean;

    const onChange = (e: KeyboardEvent) => {

        const currentTarget = <HTMLTextAreaElement>(e.currentTarget ?? e.target);
        let value = String(currentTarget.value ?? "");

        // detect autosize for the first time
        if (isAutosize === undefined) {
            isAutosize = cssHeight(currentTarget).indexOf('auto') !== -1;
        }

        if (isAutosize) {
            // @ts-ignore this should be HTMLElement, where was change / onkeyup event occurred
            this.style.height = 'auto';

            // @ts-ignore
            this.style.height = this.scrollHeight + 'px';
        }


        c.set.bind(c)(value);
        m.redraw();
    }

    return m('div.textarea', {}, [
        m('textarea', {
            id: elementId(c, c.cell.id),
            onchange: onChange,
            oninput: onChange,
            disabled: !c.cell.enabled,
            value: c.getVariable() || '',
            autocomplete: 'off',
        }),
        progressBarThermometerView(c),
    ]);
}
